export const getImageFmt = (resAst: Ast) => {
  const image_fmt: string[] = [];
  const imgAndImgArrayRes = resAst.children.filter(
    (item) => item.tag === 'Image' || item.tag === 'ImageArray'
  );
  imgAndImgArrayRes.map((item: Ast) => {
    const { format } = item.attrsMap;
    const format_name = image_fmt_list[format] ?? 'indexed8';
    if (image_fmt.findIndex((item) => item === format_name) < 0)
      image_fmt.push(format_name);
  });

  return image_fmt;
};

const image_fmt_list: any = {
  truecolor_alpha: 'ARGB8888',
  truecolor: 'XRGB8888',
  alpha8: 'XRGB8888_ALPHA',
  rgb565: '16bitRGB565',
  indexed8: 'INDEXED_8BIT',
  png: 'PNG',
  jpeg: 'JPEG',
  GIF: 'GIF',
  MP4: 'MP4'
};
